import { AxiosError } from "axios";

import { getPartnerToken } from "./get-partner-token";
import { gupshupIntegrationService } from "@/api/customer-platform/whatsapp/gupshup-integration";
import { IGupshupOnboardingRequest, IGupshupOnboardingResponse } from "@/interfaces/customer-platform.interfaces";

export async function createGupshupOnboarding(
  request: IGupshupOnboardingRequest
): Promise<IGupshupOnboardingResponse> {
  try {
    
    const partnerToken = await getPartnerToken();

    let appName = request.customerId;
    
    if (appName.length < 6) {
      
      appName = `T2B${appName.padStart(3, "0")}`;
    }
    
    if (appName.length > 150) {
      appName = appName.substring(0, 150);
    }

    const { appId } = await gupshupIntegrationService.createApp(
      appName,
      partnerToken
    );

    await gupshupIntegrationService.setAppContact(
      appId,
      request.customerData.email,
      request.customerData.nomeFantasia,
      request.customerData.telefone,
      partnerToken
    );

    let embedLink: string;
    try {
      const linkResponse = await gupshupIntegrationService.generateOnboardingLink(
        appId,
        request.customerData.nomeFantasia,
        "pt",
        partnerToken
      );
      embedLink = linkResponse.link;
    } catch (linkError) {
      const errorMessage = linkError instanceof Error ? linkError.message : "";
      if (errorMessage.includes("Max Links Already sent") || errorMessage.includes("Max Links")) {
        const appDetails = await gupshupIntegrationService.getAppDetails(appId, partnerToken);
        embedLink = "";
        return {
          appId,
          embedLink: "",
          status: appDetails.status === "active" ? "active" : "pending",
        };
      }
      throw linkError;
    }

    return {
      appId,
      embedLink,
      status: "pending",
    };
  } catch (error) {
    if (error instanceof AxiosError) {
      
      if (error.response?.status === 401 || error.message === "UNAUTHORIZED") {
        
        const newPartnerToken = await getPartnerToken();
        
        try {
          
          let appName = request.customerId;
          if (appName.length < 6) {
            appName = `T2B${appName.padStart(3, "0")}`;
          }
          if (appName.length > 150) {
            appName = appName.substring(0, 150);
          }

          const { appId } = await gupshupIntegrationService.createApp(
            appName,
            newPartnerToken
          );
          const { link: embedLink } = await gupshupIntegrationService.generateOnboardingLink(
            appId,
            request.customerData.nomeFantasia,
            "pt",
            newPartnerToken
          );
          return {
            appId,
            embedLink,
            status: "pending",
          };
        } catch (retryError) {
          throw new Error(
            `Failed to create onboarding after token refresh: ${retryError instanceof Error ? retryError.message : "Unknown error"}`
          );
        }
      }
      throw new Error(
        `Failed to create onboarding: ${error.response?.data?.message || error.message}`
      );
    }
    throw error;
  }
}
